export default "<p>additional-options works!</p>\n<app-post-purchase-navigation [target]=\"data.id\"></app-post-purchase-navigation>\n";